import React from 'react'
import './avaliationPropose.scss'
import Helmet from 'react-helmet'
import Loading from '../../../components/loading/loading'
// import AvaliationStar from "../../../components/avaliationStars/avaliationStars";
import ClicableAvaliationStar from "../../../components/clicableAvaliationStar/clicableAvaliationStar";
import TextInput from "../../../components/textInput/textInput";
import { Mutation, Query } from "react-apollo"
import { ProposeId } from '../../../queries/propose'
import AvaliationOito from '../../../components/avaliationOito/avaliationOito'
import Button from '../../../components/newButton/button'
import Simplert from 'react-simplert'
// import { Textarea } from '../../../components/TextArea/Textarea'
import { CreateRank } from '../../../queries/rank'
// import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from '../../../components/tooltip/tooltip'
import ErrorBoundary from '../../../components/errorBoundary/errorBoundary'

export default class avaliacao extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            propose: '',
            loading: true,
            user: '',
            otherUser: '',
            description: '',
            loadingChat: true,
            perfil: {},
            content: '',
            value: '',
            submitOK: false,
            showAlert: false,
            messageAlert: '',
            customCloseBtnText: 'Fechar',
            customCloseBtnClass: 'buttonnot', // colocar cor roxa
            impro: false,
        }

        // console.log(window.location.search)

        this.rank = {}

        this.setInput = event => {
            // this.setState({ description: event.target.value });
            this.rank.description = event.target.value
            // console.log(this.rank)
            if (!!this.rank.description &&
                !!this.rank.rating &&
                (!!(this.rank.custoC &&
                    this.rank.pontualidadeC &&
                    this.rank.respeitoC &&
                    this.rank.transparenciaC) ||
                    !!(this.rank.agilidade &&
                        this.rank.atendimento &&
                        this.rank.ferramentas &&
                        this.rank.solucao &&
                        this.rank.resposta &&
                        this.rank.custo &&
                        this.rank.pontualidade))) {
                this.setState({ submitOk: true })
            } else {
                this.setState({ submitOk: false })
            }

            // console.log(!!this.rank.description)
            // console.log(!!this.rank.rating)
            // console.log(!!(this.rank.custoC &&
            //     this.rank.pontualidadeC &&
            //     this.rank.respeitoC &&
            //     this.rank.transparenciaC) ||
            //     !!(this.rank.agilidade &&
            //         this.rank.atendimento &&
            //         this.rank.ferramentas &&
            //         this.rank.solucao &&
            //         this.rank.resposta &&
            //         this.rank.custo &&
            //         this.rank.pontualidade))
            // console.log(this.state.submitOK)

            return this.rank.description
        } //_setInput

        this.sendRank = CreateRank => {
            this.setState({ loading: true })

            // console.log(!!this.rank.description)
            // console.log(!!this.rank.rating)
            // console.log(!!(this.rank.custoC &&
            //     this.rank.pontualidadeC &&
            //     this.rank.respeitoC &&
            //     this.rank.transparenciaC) ||
            //     !!(this.rank.agilidade &&
            //         this.rank.atendimento &&
            //         this.rank.ferramentas &&
            //         this.rank.solucao &&
            //         this.rank.resposta &&
            //         this.rank.custo &&
            //         this.rank.pontualidade))

            let media = 0

            if (!this.state.impro) {

                if (this.rank.agilidade && this.rank.atendimento && this.rank.ferramentas && this.rank.solucao
                    && this.rank.resposta && this.rank.custo && this.rank.pontualidade) {
                    media = parseInt((this.rank.agilidade + this.rank.atendimento + this.rank.ferramentas + this.rank.solucao
                        + this.rank.resposta + this.rank.custo + this.rank.pontualidade) / 7)
                } else if (this.rank.media) {
                    media = this.rank.media
                }

                CreateRank({
                    variables: {
                        agilidade: this.rank.agilidade ? parseInt(this.rank.agilidade) : null,
                        atendimento: this.rank.atendimento ? parseInt(this.rank.atendimento) : null,
                        ferramentas: this.rank.ferramentas ? parseInt(this.rank.ferramentas) : null,
                        solucao: this.rank.solucao ? parseInt(this.rank.solucao) : null,
                        resposta: this.rank.resposta ? parseInt(this.rank.resposta) : null,
                        custo: this.rank.custo ? parseInt(this.rank.custo) : null,
                        pontualidade: this.rank.pontualidade ? parseInt(this.rank.pontualidade) : null,
                        media: media,
                        toId: this.state.otherUser.id,
                        proposeId: this.proposeId,
                        rating: this.rank.rating,
                        typeTo: this.state.impro ? "CLIENTE" : "PROFISSIONAL",
                        description: this.rank.description,
                    }
                }).then(
                    res => {
                        // console.log(res)
                        this.setState({
                            loading: false,
                            showAlert: true,
                            typeAlert: 'success',
                            titleAlert: 'Avaliação enviada com sucesso!',
                            messageAlert: 'Em breve a outra parte também avaliará você. Quanto mais serviços fizer, melhor será sua nota.',
                            onClose: () => window.location.href = `/perfil/rank`
                        })
                    }).catch(err => console.log(err))

            } else {

                if (this.rank.custoC + this.rank.pontualidadeC + this.rank.respeitoC + this.rank.transparenciaC) {
                    media = parseInt((this.rank.custoC + this.rank.pontualidadeC + this.rank.respeitoC + this.rank.transparenciaC) / 4)
                } else if (this.rank.media) {
                    media = this.rank.media
                }

                CreateRank({
                    variables: {
                        custoC: this.rank.custoC ? parseInt(this.rank.custoC) : null,
                        pontualidadeC: this.rank.pontualidadeC ? parseInt(this.rank.pontualidadeC) : null,
                        respeitoC: this.rank.respeitoC ? parseInt(this.rank.respeitoC) : null,
                        transparenciaC: this.rank.transparenciaC ? parseInt(this.rank.transparenciaC) : null,
                        media: media,
                        toId: this.state.otherUser.id,
                        proposeId: this.proposeId,
                        rating: this.rank.rating,
                        typeTo: this.state.impro ? "CLIENTE" : "PROFISSIONAL",
                        description: this.rank.description,
                    }
                }).then(
                    res => {
                        console.log(res)
                        this.setState({
                            loading: false,
                            showAlert: true,
                            typeAlert: 'success',
                            titleAlert: 'Avaliação enviada com sucesso!',
                            messageAlert: 'Em breve a outra parte também avaliará você. Quanto mais serviços fizer, melhor será sua nota.',
                            onClose: () => window.location.href = `/perfil/rank`
                        })
                    }).catch(err => console.log(err))
            }
            return null
        }
    }

    getDataFromStars = (data) => {
        // console.log(data);
        this.rank[`${data.name}`] = data.value

        if (!!this.rank.description &&
            !!this.rank.rating &&
            (!!(this.rank.custoC &&
                this.rank.pontualidadeC &&
                this.rank.respeitoC &&
                this.rank.transparenciaC) ||
                !!(this.rank.agilidade &&
                    this.rank.atendimento &&
                    this.rank.ferramentas &&
                    this.rank.solucao &&
                    this.rank.resposta &&
                    this.rank.custo &&
                    this.rank.pontualidade))) {
            this.setState({ submitOk: true })
        } else {
            this.setState({ submitOk: false })
        }
    }

    render() {
        this.proposeId = window.location.pathname.split('/')[(window.location.pathname.split('/').length - 1)]
        const cache = JSON.parse(sessionStorage.getItem('OITO'))

        this.noresponse = false

        if (window.location.search === "?noresponse") {
            this.noresponse = true
        }

        if (!cache) {
            if (!this.state.showAlert) this.setState({
                showAlert: true,
                typeAlert: 'error',
                titleAlert: 'Você não está logado',
                messageAlert: 'Entre ou cadastre-se. É gratuito!',
                onClose: () => window.location.href = '/login'
            })
            window.setTimeout(window.location.href = '/login', 2000)
        } else {
            this.playerId = cache.user.id
        }

        return (
            <div className="col-xs-12" style={{ maxWidth: '980px'}}>
                <Helmet title="Oito - Avaliar">
                    <meta name="description" content="Avalie a qualidade dos serviços prestados pelos profissionais encontrados em Oito.app, ou de clientes que contrataram serviços em Oito.app." />
                    <meta name="keywords" content="Avaliação, Profissionais, Oportunidades" />
                    <meta name="robots" content="index, follow" />
                    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
                    <meta name="language" content="Portuguese" />
                    <meta name="revisit-after" content="1 days" />
                </Helmet>
                <Simplert
                    showSimplert={this.state.showAlert}
                    type={this.state.typeAlert}
                    title={this.state.titleAlert}
                    message={this.state.messageAlert}
                    customCloseBtnText={this.state.customCloseBtnText}
                    customCloseBtnClass={this.state.customCloseBtnClass}
                    onClose={this.state.onClose}
                />
                <Query query={ProposeId} variables={{ id: this.proposeId }}>
                    {result => {
                        if (result.loading) return <Loading />
                        if (result.error) return <p>{result.error.message}</p>
                        // console.log(result.data.allProposes[0])
                        let otherUser, player
                        const propose = result.data.propose

                        if (propose.from.id === this.playerId) {
                            otherUser = propose.to
                            player = propose.from
                        } else {
                            otherUser = propose.from
                            player = propose.to
                            if (!this.state.impro) this.setState({ impro: true })
                        }

                        if (this.state.otherUser === '' || this.state.propose === '' || this.state.player === '') {
                            this.setState({ otherUser, propose, player })
                        }

                        if (propose.ranks && propose.ranks.length > 0) {
                            propose.ranks.find(rank => {
                                // console.log(rank)
                                return rank.from.id === this.playerId ?
                                    !this.state.showAlert ? this.setState({
                                        showAlert: true,
                                        typeAlert: 'error',
                                        titleAlert: 'Você já avaliou esta proposta.',
                                        messageAlert: 'Esta proposta já foi avaliada por você. Clique para voltar aos detalhes da proposta',
                                        onClose: () => window.location.href = '/perfil/proposedetails/' + this.proposeId
                                    })
                                        : null : null
                            })
                        }

                        return (
                            <div className="proposeAvaliation row center-xs">
                                <section className='header col-xs-12'>
                                    <h1>Avalie {otherUser.name} - {propose.anuncio.skill.name}</h1>
                                    {!this.state.impro ? <p><small>Você pode qualificar o serviço que contratou dando estrelas de 1 a 5, sendo 1 quando você estiver totalmente insatisfeito e 5 quando estiver totalmente satisfeito. Assim você qualifica prestadores de serviço, otimiza nossa plataforma e ajuda outros clientes.</small></p> :
                                        <p><small>Você pode qualificar o cliente que contratou seus serviços dando estrelas de 1 a 5, sendo 1 quando você estiver totalmente insatisfeito e 5 quando estiver totalmente satisfeito. Assim você qualifica clientes, otimiza nossa plataforma e ajuda outros profissionais.</small></p>}
                                </section>

                                <section className={'notes col-xs-12'}>
                                    <div className={'questions row'}>
                                        <h2>Classifique</h2>
                                        {this.noresponse ?
                                            <div className="col-xs-12">
                                                <Tooltip text='Como você avalia seu contato com a outra parte? Mesmo com o serviço não realizado, a comunicação foi boa? Foi educado, deu as devidas explicações? Retornou em tempo habil?' />
                                                <span>Avalie sua experiência com o {this.state.impro ? "cliente" : "profissional"}.</span>
                                                <ErrorBoundary><ClicableAvaliationStar name="media" callbackFunctions={this.getDataFromStars.bind(this)} /></ErrorBoundary>

                                            </div>
                                            : this.state.impro ? <div className="row center-xs bottom-xs listnotes">
                                                <div className="col-xs-12 row" style={{ maxWidth: "500px"}}>
                                                    <Tooltip text='O valor pago é justo em relação ao serviço prestado?' />
                                                    <span>Custo-benefício</span>
                                                    <ErrorBoundary><ClicableAvaliationStar name="custoC" callbackFunctions={this.getDataFromStars.bind(this)} /></ErrorBoundary>
                                                </div>

                                                <div className="col-xs-12 row" style={{ maxWidth: "500px", marginTop: "15px" }}>
                                                    <Tooltip text='O cliente que contratou seu serviço pagou de forma pontual?' />
                                                    <span>Pontualidade no pagamento</span>

                                                    <ErrorBoundary><ClicableAvaliationStar name="pontualidadeC" callbackFunctions={this.getDataFromStars.bind(this)} /></ErrorBoundary>
                                                </div>

                                                <div className="col-xs-12 row" style={{ maxWidth: "500px", marginTop: "15px"  }}>
                                                    <Tooltip text='O cliente que contratou você foi respeitoso e atencioso durante sua prestação de serviço?' />
                                                    <span>Respeito no atendimento</span>

                                                    <ErrorBoundary><ClicableAvaliationStar name="respeitoC" callbackFunctions={this.getDataFromStars.bind(this)} /></ErrorBoundary>
                                                </div>

                                                <div className="col-xs-12 row" style={{ maxWidth: "500px", marginTop: "15px"  }}>
                                                    <Tooltip text='A descrição do serviço estava coerente com o que fora executado?' />
                                                    <span>Transparência no serviço</span>

                                                    <ErrorBoundary><ClicableAvaliationStar name="transparenciaC" callbackFunctions={this.getDataFromStars.bind(this)} /></ErrorBoundary>
                                                </div>
                                            </div>
                                                :
                                                <div className="row center-xs bottom-xs listnotes">
                                                    <div className="col-xs-12 row" style={{ maxWidth: "500px", marginTop: "15px"  }}>
                                                        <Tooltip text='O serviço foi feito de forma ágil e eficiente?' />
                                                        <span>Agilidade no serviço</span>
                                                        <ErrorBoundary><ClicableAvaliationStar name="agilidade" callbackFunctions={this.getDataFromStars.bind(this)} /></ErrorBoundary>
                                                    </div>

                                                    <div className="col-xs-12 row" style={{ maxWidth: "500px", marginTop: "15px"  }}>
                                                        <Tooltip text='O prestador de serviço atendeu você com respeito, dedicação e transparência?' />
                                                        <span>Atendimento</span>
                                                        <ErrorBoundary><ClicableAvaliationStar name="atendimento" callbackFunctions={this.getDataFromStars.bind(this)} /></ErrorBoundary>
                                                    </div>

                                                    <div className="col-xs-12 row" style={{ maxWidth: "500px", marginTop: "15px"  }}>
                                                        <Tooltip text='Como você avalia a relação de valores e entrega do serviço?' />
                                                        <span>Custo-benefício</span>
                                                        <ErrorBoundary><ClicableAvaliationStar name="custo" callbackFunctions={this.getDataFromStars.bind(this)} /></ErrorBoundary>
                                                    </div>

                                                    <div className="col-xs-12 row" style={{ maxWidth: "500px", marginTop: "15px"  }}>
                                                        <Tooltip text='O prestador de serviço levou todas as ferramentas necessárias para a execução do serviço?' />
                                                        <span>Ferramentas necessárias</span>
                                                        <ErrorBoundary><ClicableAvaliationStar name="ferramentas" callbackFunctions={this.getDataFromStars.bind(this)} /></ErrorBoundary>
                                                    </div>

                                                    <div className="col-xs-12 row" style={{ maxWidth: "500px", marginTop: "15px"  }}>
                                                        <Tooltip text='Todos os prazos combinados durante a negociação e execução dos serviços foram cumpridos sem atrasos?' />
                                                        <span>Pontualidade</span>
                                                        <ErrorBoundary><ClicableAvaliationStar name="pontualidade" callbackFunctions={this.getDataFromStars.bind(this)} /></ErrorBoundary>
                                                    </div>

                                                    <div className="col-xs-12 row" style={{ maxWidth: "500px", marginTop: "15px"  }}>
                                                        <Tooltip text='O prestador de serviço usou o chat de forma ágil, respeitosa e clara?' />
                                                        <span>Respostas no chat</span>
                                                        <ErrorBoundary><ClicableAvaliationStar name="resposta" callbackFunctions={this.getDataFromStars.bind(this)} /></ErrorBoundary>
                                                    </div>

                                                    <div className="col-xs-12 row" style={{ maxWidth: "500px", marginTop: "15px"  }}>
                                                        <Tooltip text='O prestador de serviço contratado solucionou seu problema de forma eficiente?' />
                                                        <span>Solução do problema</span>
                                                        <ErrorBoundary><ClicableAvaliationStar name="solucao" callbackFunctions={this.getDataFromStars.bind(this)} /></ErrorBoundary>
                                                    </div>
                                                </div>
                                        }
                                    </div>

                                    <div className="row satisfaction">
                                        <h2>Qual sua satisfação com o cliente?</h2>
                                        <div className="col-xs-12">
                                        <ErrorBoundary><AvaliationOito name="rating" callbackFunctions={this.getDataFromStars.bind(this)} /></ErrorBoundary>
                                        </div>
                                    </div>
                                </section>

                                <section className="col-xs-12 row comment">
                                    <h2>Comentário</h2><Tooltip text='Deixe um comentário de recomendação. Seja educado, o comentário é publico, mas não exibe o autor.' />
                                    
                                    <form className="col-xs-12" >
                                        <TextInput placeholder='Digite aqui um comentário sobre o profissional' name="menssage" onInput={this.setInput} required={true} />
                                        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                                            <ErrorBoundary><Mutation mutation={CreateRank}>
                                                {(CreateRank, { loading, error }) => {
                                                    if (loading) return <Loading />
                                                    if (error) return console.log(CreateRank.error)

                                                    return <Button
                                                        name='Salvar avaliação'
                                                        type='submit'
                                                        disabled={(!!this.rank.description &&
                                                            !!this.rank.rating &&
                                                            (!!(this.rank.custoC &&
                                                                this.rank.pontualidadeC &&
                                                                this.rank.respeitoC &&
                                                                this.rank.transparenciaC) ||
                                                                !!(this.rank.agilidade &&
                                                                    this.rank.atendimento &&
                                                                    this.rank.ferramentas &&
                                                                    this.rank.solucao &&
                                                                    this.rank.resposta &&
                                                                    this.rank.custo &&
                                                                    this.rank.pontualidade) || !!this.rank.media)) ? false : true}
                                                        onClick={() => this.sendRank(CreateRank)}
                                                    />
                                                }}
                                            </Mutation></ErrorBoundary>
                                        </div>
                                    </form>
                                </section>
                            </div>
                        )
                    }}
                </Query>
            </div>
        )
    }
}
